import Vue from 'vue'
import VueLocalStorage from "vue-localstorage"

import { service } from "@/api/api"

Vue.use(VueLocalStorage)

export default {
  state: {},

  getters: {},

  mutations: {},

  actions: {
    async updateRightholder({},payload){
      console.log("payload: ",payload)
      let res = await service.updateRightholder(payload)
      return res
    },

    async createRightholder({},payload){
      let res = await service.createRightholder(payload)
      return res
    }
  }
}